import { useTranslation } from 'react-i18next';
import { useOrganizationPurchase } from 'features/organizations/hooks/useOrganizationPurchase';
import { Grid2, Typography } from '@mui/material';
import { formatToUSDollars } from 'shared/utils';
import { OrganizationPurchase } from 'features/organizations/organizations.types';

interface OrganizationPurchaseSummaryProps {
  regularSeats: number;
  proSeats: number;
}

export const OrganizationPurchaseSummary = (
  props: OrganizationPurchaseSummaryProps,
): JSX.Element => {
  const { regularSeats = 0, proSeats = 0 } = props;
  const { t } = useTranslation();

  const {
    previewPurchase: purchasePreview,
    isLoading,
    isError,
  } = useOrganizationPurchase({
    processOrganizationPurchase: {
      regularSeats: regularSeats || 0,
      proSeats: proSeats || 0,
    },
  });

  const summary: Partial<OrganizationPurchase> =
    isLoading || !purchasePreview
      ? { subtotal: undefined, savings: undefined, total: undefined }
      : purchasePreview;

  const displayNumber = (num: number | undefined): string => {
    if (isLoading || isError) {
      return '-';
    }
    return formatToUSDollars(num || 0, 2);
  };

  return (
    <Grid2 container size={12} spacing={2}>
      <Grid2 size={4} />
      <Grid2 size={8}>
        <Grid2 container justifyContent="space-between" alignItems="center">
          <Typography style={{ textAlign: 'right', flex: 1 }}>
            {t('organizationPurchase.subtotal')}
          </Typography>
          <Typography style={{ textAlign: 'right', flex: 1 }}>
            {displayNumber(summary.subtotal)}
          </Typography>
        </Grid2>
        <Grid2 container justifyContent="space-between" alignItems="center">
          <Typography style={{ textAlign: 'right', flex: 1 }}>
            {t('organizationPurchase.savings')}
          </Typography>
          <Typography style={{ textAlign: 'right', flex: 1 }}>
            {displayNumber(summary.savings)}
          </Typography>
        </Grid2>
        <Grid2 container justifyContent="space-between" alignItems="center">
          <Typography style={{ textAlign: 'right', flex: 1 }}>
            <b>{t('organizationPurchase.total')}</b>
          </Typography>
          <Typography style={{ textAlign: 'right', flex: 1 }}>
            <b>{displayNumber(summary.total)}</b>
          </Typography>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};
